var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',[_c('span',[_c('i',{staticClass:"f7-icons standardIconWidth"},[_vm._v(" info_circle_fill ")]),_vm._v(" "),_c('span',{staticClass:"infoIconText"},[_vm._v("\n        "+_vm._s(_vm.$t('samplesRegister.minimumOrderHandlingFee'))+"\n      ")])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }